// removed by extract-text-webpack-plugin
module.exports = {"modal-opener":"modal-opener___Mz5Tj","family-modal-wrap":"family-modal-wrap___2brpm shadow-broad___37axf","family-modal-flex":"family-modal-flex___3iZcF center___2iqBf","family-modal-close-wrap":"family-modal-close-wrap___2QaBE","family-modal-close":"family-modal-close___1I3Ns","media-react-player-wrap":"media-react-player-wrap___-9EPg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/VideoModal/VideoModal.css
// module id = 921
// module chunks = 0